module.exports = __webpack_public_path__ + "media/images/vector_thick_circle-7e7f95ec5bcd7797b8950c62b870291b.svg";